import styled, { css } from 'styled-components';
import { LARGE_BUTTON_HEIGHT } from '../../../components/config/themeVariable';
import { FOCUS_HALO_REACH, selfPaddedScrollGutter } from './scrollGutter';

const pinnedActionsTopPadding = `calc(var(--spacing-gutter) - ${FOCUS_HALO_REACH})`;

/** Keeps a form's save button at the bottom of its scrolling form; a form that fits shows it right under the last field. */
export const PinnedFormActions = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  /* the margin and padding cancel out, so the form's own gap stays and a focused field's halo is not covered */
  margin-top: calc(-1 * ${pinnedActionsTopPadding});
  padding-top: ${pinnedActionsTopPadding};
  padding-bottom: var(--spacing-gutter);
  background-color: var(--clr-container-bg);
`;

/** For the box the fields scroll in, so the pinned actions neither hide a focused field nor move. */
export const pinnedActionsScroller = css`
  scroll-padding-bottom: calc(
    ${pinnedActionsTopPadding} + ${LARGE_BUTTON_HEIGHT}px + var(--spacing-gutter)
  );
  /* macOS rubber-band overscroll would drag the stuck button along with the bouncing fields */
  overscroll-behavior-y: none;
`;

export const formCardStyles = css`
  width: 100%;
  max-height: 100%;
  background-color: var(--clr-container-bg);
  border-radius: 10px;
  padding: var(--spacing-gutter);
  overflow-y: auto;
  /* the card cannot grow past its column, so the scrollbar strip comes out of its own padding */
  ${selfPaddedScrollGutter('var(--spacing-gutter)')}

  /* the pinned actions bring their own bottom padding, so they meet the card's edge while stuck */
  &:has(${PinnedFormActions}) {
    padding-bottom: 0;
    ${pinnedActionsScroller}
  }
`;

export const FormCard = styled.div`
  ${formCardStyles}
`;
